import { render, staticRenderFns } from "./DeliveryCompanyEdit.vue?vue&type=template&id=cf7767b8&lang=pug"
import script from "./DeliveryCompanyEdit.vue?vue&type=script&lang=js"
export * from "./DeliveryCompanyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports